import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Password reset. Sign in with your new password.");
      navigate("/login");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <main data-testid="reset-password-page" className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-12">
          <Link to="/" className="font-display text-3xl gold-text">y ℶα</Link>
          <h1 className="font-display text-4xl mt-8 tracking-tight">New password.</h1>
        </div>
        {!token ? (
          <div className="lux-card p-8 text-center">
            <div className="font-display text-xl">Invalid or missing token.</div>
            <Link to="/forgot-password" className="btn-ghost inline-block mt-6">Request new link</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-7">
            <div>
              <label className="text-xs uppercase tracking-[0.25em] text-muted-fg">New password</label>
              <input data-testid="reset-password" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="At least 6 characters" className="lux-input mt-2" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.25em] text-muted-fg">Confirm password</label>
              <input data-testid="reset-password-confirm" type="password" required minLength={6} value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Re-enter password" className="lux-input mt-2" />
            </div>
            <button data-testid="reset-submit" disabled={loading} className="btn-gold w-full">
              {loading ? "Resetting…" : "Reset password"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
